import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { FlightCampaignsCarousel } from './FlightCampaignsCarousel'
import { useFlightCampaigns } from 'hooks/Flights/useFlightCampaigns'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import TextButton from 'LuxKit/Button/TextButton'
import { HOME_PAGE_CAMPAIGNS_THRESHOLD } from 'hooks/Flights/useCampaignsOrDeals'

export function HomepageFlightCampaigns() {
  const intl = useIntl()
  const [campaigns, fetchingCampaigns] = useFlightCampaigns()

  const showCampaigns = campaigns.length > 0 && !fetchingCampaigns && campaigns.length >= HOME_PAGE_CAMPAIGNS_THRESHOLD

  const allCampaign: App.FlightCampaign | undefined = useMemo(() => {
    return campaigns.find(campaign => campaign.type === 'all')
  }, [campaigns])

  if (!showCampaigns) {
    return null
  }

  return (
    <VerticalSpacer gap={24} data-testid="flight-campaigns-carousel">
      <LayoutContainer>
        <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
          <HeadingTextBlock variant="heading2">
            {intl.formatMessage({
              id: 'bGdCJJ3FAO',
              defaultMessage: 'Flight deals',
              description: 'Heading for the flight campaigns section on the homepage',
            })}
          </HeadingTextBlock>

          {allCampaign && (
            <TextButton kind="tertiary" size="medium" to={`/flights/campaigns/${allCampaign.id}`} target="_blank">
              {intl.formatMessage({
                id: 'mh21DRtLA2',
                defaultMessage: 'View all',
                description: 'Button text to view all flight campaign deals',
              })}
            </TextButton>
          )}
        </Group>
      </LayoutContainer>

      <FlightCampaignsCarousel campaigns={campaigns} />
    </VerticalSpacer>
  )
}
